import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'
import async from 'async'
import { isEqual } from 'lodash'

import {
  FILE_STORAGE
} from '../../../constants'

// import style
import './index.scss'

// import components
import Modal from '../../components/Modal'

// Utils
import { translation } from '../../../utils/helpers'

// Actions
import {
  GetForsiDraftEnums,
  CreateForsiDraft,
  GetForsiDamageTypes,
  UpdateForsiDraft
} from '../../../actions/forsitoken'
import { getOrder, uploadFileToOrder } from '../../../actions/orders'

// Elements
import { MainMenuIcons } from '../../elements/icons'
import TabBar from '../../elements/tabBar'
import TabItem from '../../elements/tabItem'
import DropDown from '../../elements/dropDown'
import Row from '../../elements/row'
import Col from '../../elements/col'
import Check from '../../elements/check'
import Text from '../../elements/text'
import Radio from '../../elements/radio'
import Gallery from '../../components/Gallery'
import PanelHeader from '../../elements/panelHeader'
import DecimalInput from '../../components/DecimalInput'
import DateTime from '../../elements/datetime'
import LabelWrapper from '../../elements/labelWrapper'
import Dropzone from '../../components/Dropzone'

class NewForsiRPModal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      overflowHidden: false,
      step: 1,
      forsiReport: {
        OrderId: props.order ? props.order.Id : null,
        DistanceDriven: props.order.DistanceDriven ? props.order.DistanceDriven : '',
        RegNumber: props.order.RegNumber ? props.order.RegNumber : '',
        ChassisNumber: props.order.ChassisNumber ? props.order.ChassisNumber : '',
        // since we d'ont have ModelYear all the time from vehicle info, we take it from the vehicle's first registration date.
        ModelYear: !props.order.RegistrationDate ? '' : props.order.RegistrationDate.split('-')[2] !== undefined ? props.order.RegistrationDate.split('-')[2] : '', // 25-06-2021
        InsuranceCompanyId: 0,
        DamageZones: [],
        PlateTypeId: 0,
        DamageTypeId: 0,
        Images: [],
        IncidentDate: props.order.InsuranceDamageDate ? props.order.InsuranceDamageDate : null
      },
      allZones: [],
      plateTypes: [],
      damageTypes: [],
      markedImages: [],
      insuranceCompany: null,
      showSpinner: false,
      loadingDamageTypes: false,
      loadingEnums: true,
      upload: {
        loading: false,
        errors: []
      }
    }

    this.handleCreateOrder = this.handleCreateOrder.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onChangeDate = this.onChangeDate.bind(this)
    this.onChangeForsi = this.onChangeForsi.bind(this)
    this.onChangePlate = this.onChangePlate.bind(this)
    this.onChangeZones = this.onChangeZones.bind(this)
    this.handleSpinner = this.handleSpinner.bind(this)
    this.handleLoadingDamageTypes = this.handleLoadingDamageTypes.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.handleRequiredInputs = this.handleRequiredInputs.bind(this)
    this.isDamageType = this.isDamageType.bind(this)
    this.isPlateType = this.isPlateType.bind(this)
    this.getImageFiles = this.getImageFiles.bind(this)
  }

  componentDidMount () {
    this.props.GetForsiDraftEnums().then(res => {
      this.setState({
        allZones: res.data.DamageZones,
        plateTypes: res.data.LicensePlateTypes,
        damageTypes: res.data.DamageTypes,
        loadingEnums: false,
        markedImages: this.props.order.OrderFiles.map(item => true)
      }, () => {
        if (this.props.order) {
          if (this.props.order.InsuranceCompanyId) {
            if (this.props.order.InsuranceCompanyId > 0) {
              this.onChangeForsi({
                target: {
                  name: 'InsuranceCompanyId',
                  value: this.props.order.InsuranceCompanyId
                }
              })
            }
          }
        }
      })
    })
    .catch(err => {
      console.log(err)
    })
  }

  componentDidUpdate (prevProps) {
    if (!isEqual(prevProps.order.OrderFiles, this.props.order.OrderFiles)) {
      this.setState({
        markedImages: this.props.order.OrderFiles.map(item => true)
      })
    }
  }

  handleSpinner (value) {
    this.setState({ showSpinner: value })
  }

  handleLoadingDamageTypes (value) {
    this.setState({ loadingDamageTypes: value })
  }

  handleCreateOrder (e) {
    const { forsiReport, markedImages } = this.state
    let dataObj = { ...forsiReport }

    const imgFiles = []
    this.props.order.OrderFiles.map(file => {
      if (file.IsImage) imgFiles.push(file)
    })

    const images = []
    markedImages.map((value, index) => {
      if (value) {
        images.push(imgFiles[index])
      }
    })

    dataObj.OrderId = this.props.order.Id
    dataObj.Images = images

    this.handleSpinner(true)
    if (this.handleRequiredInputs(dataObj)) {
      this.props.CreateForsiDraft(dataObj).then(res => {
        this.props.getOrder(forsiReport.OrderId)
        .then(res => {
          this.handleSpinner(false)
          this.props.onSuccess(res.data)
        })
        .catch(err => {
          this.handleErrors(err)
          this.handleSpinner(false)
          this.props.onSuccess()
        })
      })
      .catch(err => {
        this.handleErrors(err)
        this.handleSpinner(false)
      })
    } else {
      this.handleSpinner(false)
    }
  }

  handleRequiredInputs (draft) {
    let errors = []

    if (!draft.PlateTypeId === 0) {
      errors.push(translation('16492'))
    }

    if (draft.DamageZones.length === 0) {
      errors.push(translation('16493'))
    }

    if (!draft.DamageTypeId === 0) {
      errors.push(translation('16494'))
    }

    if (draft.ChassisNumber.length === 0) {
      errors.push(translation('16495'))
    }

    if (draft.DistanceDriven.length === 0) {
      errors.push(translation('16496'))
    }

    if (draft.ModelYear.length === 0) {
      errors.push(translation('16497'))
    }

    if (draft.RegNumber.length === 0) {
      if (draft.PlateTypeId) {
        if (draft.PlateTypeId !== 1) {
          errors.push(translation('16498'))
        }
      } else {
        errors.push(translation('16498'))
      }
    }

    // if (!draft.IncidentDate) {
    //   errors.push(translation('16500'))
    // }

    if (draft.InsuranceCompanyId <= 0) {
      errors.push(translation('16502'))
    }

    if (errors.length > 0) {
      let errText = ''
      for (let i = 0; i < errors.length; i++) {
        errText += '<br/>' + errors[i]
      }
      this.handleErrors(errText)
      return false
    } else {
      return true
    }
  }

  handleErrors (err) {
    if (err) {
      if (err.response) {
        if (err.response.data !== undefined && err.response.data !== null && Array.isArray(err.response.data) && err.response.data.length > 0) {
          let errors = err.response.data
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
            if (dictKey === 16501 || dictKey === '16501') {
              this.props.onTokenExpired()
            }
          }
          window.toastr.error(translation(errText), translation('216'))
        } else {
          window.toastr.error(translation('910'), translation('216'))
        }
      } else {
        window.toastr.error(err, translation('216'))
      }
    }
  }

  onChange (e) {
    const { forsiReport } = this.state
    this.setState({ forsiReport: { ...forsiReport, [e.target.name]: e.target.value } })
  }

  onBlur (e) {
    // Empty method. It is used to deter errors thrown by DecimalInput
    // which requires onBlur
  }

  onChangeDate (e) {
    const { forsiReport } = this.state
    this.setState({ forsiReport: { ...forsiReport, IncidentDate: e.toDate() } })
  }

  async onChangeForsi (e) {
    let { forsiReport } = this.state

    this.handleLoadingDamageTypes(true)
    await this.props.GetForsiDamageTypes(e.target.value)
    .then(resp => {
      var data = resp.data
      if (data) {
        if (Array.isArray(data)) {
          if (data.length > 0) {
            this.setState({
              forsiReport: {
                ...forsiReport,
                [e.target.name]: e.target.value
              },
              damageTypes: data,
              loadingDamageTypes: false
            })
          }
        }
      }
    })
    .catch(err => {
      console.log(err)
    })
  }

  onChangeImages (e, file, index) {
    const { markedImages } = this.state

    markedImages[index] = !markedImages[index]

    this.setState({
      markedImages
    })
  }

  onChangePlate (e) {
    const { forsiReport } = this.state

    this.setState({
      forsiReport: {
        ...forsiReport,
        [e.target.name]: parseInt(e.target.value)
      }
    })
  }

  onChangeDamageType (e, type) {
    const { forsiReport } = this.state

    this.setState({
      forsiReport: {
        ...forsiReport,
        [e.target.name]: type.Id
      }
    })
  }

  onChangeZones (e, zone) {
    const { forsiReport } = this.state

    let updateObj = {
      ...forsiReport
    }

    if (updateObj[e.target.name].includes(zone)) {
      updateObj[e.target.name] = updateObj[e.target.name].filter(val => val.Id !== zone.Id)
    } else {
      updateObj[e.target.name].push(zone)
    }

    this.setState({
      forsiReport: {
        ...updateObj
      }
    })
  }

  renderGallery (files) {
    const { markedImages } = this.state

    if (files.length === 0) {
      return null
    }

    const renderImage = (image, index) => {
      let url = FILE_STORAGE + image.ThumbURL
      let fullUrl = FILE_STORAGE + image.FileURL

      return (
        <div key={index}>
          <div className='divImg'>
            <img className='img2' src={url} />
            <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
          </div>
          <div className='divCheckbox'>
            <Check spacing={0} labelText={translation('1218')} name='Images' value={image} onChange={e => this.onChangeImages(e, image, index)} checked={markedImages[index]} />
          </div>
        </div>
      )
    }

    return <Gallery files={files} renderImage={renderImage} />
  }

  renderStepTwo () {
    let imgFiles = this.getImageFiles()

    const onDrop = () => {
      this.setState({
        upload: {
          ...this.state.upload,
          errors: []
        }
      })
    }

    const onDropAccepted = (files) => {
      let newErrors = []
      this.setState({
        upload: {
          ...this.state.upload,
          loading: true,
          errors: []
        }
      })

      async.each(files, (file, cb) => {
        // Upload each file
        this.props.uploadFileToOrder(file, this.props.order.Id).then((res) => {
          cb()
        }, () => {
          newErrors.push(`${translation('1207')}: ${file.name} ${translation('13406')}.`)
          cb()
        })
      }, () => {
        if (newErrors.length !== 0) {
          this.setState({
            upload: {
              ...this.state.upload,
              errors: this.state.upload.errors.concat(newErrors)
            }
          })
        }

        this.setState({
          upload: {
            ...this.state.upload,
            loading: false
          }
        }, () => this.props.getOrder(this.props.order.Id))
      })
    }

    const onDropRejected = (files) => {
      const newErrors = files.map(file => `${translation('1207')}: ${file.name} ${translation('13405')}.`)
      this.setState({
        upload: {
          ...this.state.upload,
          errors: newErrors
        }
      })
    }

    return (
      <div>
        <div className='newForsiReport__photos'>
          <div>&nbsp;</div>
          <div>
            <LabelWrapper labelText={translation(1011)}>
              {this.state.upload.errors.length !== 0 && (
                <div className='alert alert-danger'>{this.state.upload.errors.map((err, key) => <p key={key}>{err}</p>)}</div>
              )}
              <Dropzone
                onDrop={onDrop}
                onDropAccepted={onDropAccepted}
                onDropRejected={onDropRejected}
                multiple
                includeCircles={false}
              >
                <p>{translation('13397')}</p>
              </Dropzone>
              {imgFiles.length === 0 && <PanelHeader text={translation(16504)} />}
              {imgFiles.length > 0 && (
                this.renderGallery(imgFiles)
              )}
            </LabelWrapper>
          </div>
          <div>&nbsp;</div>
        </div>
      </div>
    )
  }

  isDamageType (type) {
    const { forsiReport } = this.state
    if (!forsiReport.DamageType) return false
    return forsiReport.DamageType.ForsiDamageTypeId === type.Id
  }

  isPlateType (index) {
    const { forsiReport, plateTypes } = this.state
    if (!forsiReport.PlateType) return false
    return forsiReport.PlateType.Name === plateTypes[index]
  }

  getImageFiles () {
    const { order } = this.props
    let imgFiles = []

    if (order.OrderFiles) {
      order.OrderFiles.map(file => {
        if (file.IsImage) imgFiles.push(file)
      })
    }

    return imgFiles
  }

  renderSpinner (name = 'showSpinner') {
    if (!this.state[name]) return null

    return [
      <div className='divider' key='1' />,
      <div className='newForsiReport__spinner' key='2'>
        <span className='animated-background'>
          <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
        </span>
      </div>
    ]
  }

  renderStepOne () {
    const { insuranceCompanies, order } = this.props
    const { allZones, plateTypes, forsiReport, damageTypes, loadingDamageTypes } = this.state

    // console.log(order)

    return (
      <div>
        <Row>
          <Col>
            {/* <PanelHeader text={translation('418')} /> */}
            <div className='newForsiReport__col'>
              <DropDown name='InsuranceCompanyId' value={this.state.forsiReport.InsuranceCompanyId} onChange={this.onChangeForsi} labelText={translation('418')}>
                <option value='0'>{translation('418')}</option>
                {insuranceCompanies.map((val, index) => {
                  if (val.Active) {
                    if (val.InsuranceCompanyId === order.InsuranceCompanyId) {
                      return (
                        <option value={val.InsuranceCompanyId} key={index} selected>{val.Company}</option>
                      )
                    } else {
                      return (
                        <option value={val.InsuranceCompanyId} key={index}>{val.Company}</option>
                      )
                    }
                  }
                })}
              </DropDown>
              <Text labelText={translation('78')} onChange={this.onChange} name='RegNumber' value={forsiReport.RegNumber} />
              <DecimalInput decimals={0} labelText={translation('860')} onChange={this.onChange} onBlur={this.onBlur} name='DistanceDriven' value={forsiReport.DistanceDriven} />
              <DecimalInput decimals={0} labelText={translation('148')} onChange={this.onChange} onBlur={this.onBlur} name='ModelYear' value={forsiReport.ModelYear} />
              <Text labelText={translation('81')} onChange={this.onChange} name='ChassisNumber' value={forsiReport.ChassisNumber} />
              <DateTime
                inputProps={{
                  name: 'IncidentDate',
                  readOnly: true,
                  placeholder: translation('1728')
                }}
                dateFormat='DD-MM-YYYY'
                timeFormat={false}
                value={moment(forsiReport.IncidentDate)}
                closeOnSelect
                onChange={this.onChangeDate}
                labelText={translation('16572')}
              />
              <div>
                {/* <PanelHeader text={translation('16481')} /> */}
                <LabelWrapper labelText={translation('16577')}>
                  {this.renderSpinner('loadingEnums')}
                  {plateTypes.map((plate, index) => {
                    return (
                      <Radio
                        key={`${plate.Id}-key`}
                        id={`${plate.Id}-index`}
                        name='PlateTypeId'
                        value={plate.Id}
                        onChange={this.onChangePlate}
                        checked={forsiReport.PlateTypeId === plate.Id}
                        labelText={translation(plate.DictionaryKey)}
                      />
                    )
                  })}
                </LabelWrapper>
              </div>
            </div>
          </Col>
          <Col>
            {/* <PanelHeader text={translation('16480')} /> */}
            <div className='newForsiReport__col'>
              <LabelWrapper labelText={translation('16480')}>
                {this.renderSpinner('loadingEnums')}
                {allZones.map((zone, index) => {
                  return <Check key={`${zone.Name}-key`} id={`${zone}-index`} name='DamageZones' value={allZones[index].Name} onChange={e => this.onChangeZones(e, zone)} checked={forsiReport.DamageZones.includes(zone)} labelText={translation(zone.DictionaryKey)} />
                })}
              </LabelWrapper>
            </div>
          </Col>
          <Col>
            {/* <PanelHeader text={translation('16478')} /> */}
            <LabelWrapper labelText={translation('16478')}>
              {this.renderSpinner('loadingDamageTypes')}
              {this.renderSpinner('loadingEnums')}
              {loadingDamageTypes ? null : damageTypes.map((type, index) => {
                return (
                  <Radio
                    key={`${type.Id}-key`}
                    id={`${type.Id}-index`}
                    name='DamageTypeId' value={type.Id}
                    onChange={e => this.onChangeDamageType(e, type)}
                    checked={forsiReport.DamageTypeId === type.Id}
                    labelText={translation(type.DictionaryKey) || type.Name}
                  />
                )
              })}
            </LabelWrapper>
          </Col>
        </Row>
      </div>
    )
  }

  renderHeader (step) {
    if (this.state.showSpinner) return this.renderSpinner()
    const imagesFound = this.getImageFiles().length

    return (
      <div className='newForsiReport__header'>
        <TabBar>
          <TabItem><Link className={step === 1 ? 'active' : ''} onClick={e => this.setState({ step: 1 })}>{translation('16478')}</Link></TabItem>
          <TabItem><Link className={step === 2 ? 'active' : ''} onClick={e => this.setState({ step: 2 })}>{`${translation('1011')} (${imagesFound})`}</Link></TabItem>
        </TabBar>
      </div>
    )
  }

  render () {
    let { step, showSpinner } = this.state

    let renderView = () => null
    let bottomBarProps = null
    switch (step) {
      case 1:
      default:
        renderView = () => this.renderStepOne()
        bottomBarProps = {
          actionLabelText: translation('237'),
          onActionClick: () => this.setState({ step: 2 }),
          cancelLabelText: false
        }
        break
      case 2:
        renderView = () => this.renderStepTwo()
        bottomBarProps = {
          actionLabelText: translation('16475'),
          onActionClick: this.handleCreateOrder,
          cancelLabelText: false
        }
        break
    }

    return (
      <div className='newForsiReport'>
        <Modal
          {...this.props}
          header={translation('13438')}
          overflowHidden={this.state.overflowHidden}
          icon={MainMenuIcons.Forsi_White}
          bottomBarProps={bottomBarProps}
        >
          {this.renderHeader(step)}
          <div>
            {!showSpinner && renderView()}
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  GetForsiDraftEnums,
  CreateForsiDraft,
  GetForsiDamageTypes,
  UpdateForsiDraft,
  getOrder,
  uploadFileToOrder
})(NewForsiRPModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewForsiRPModal/index.js